import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NoEncryptionIcon(props: IconProps) {
    return <Icon {...props} iconKey={"no_encryption"}/>
}
